import { createBrowserRouter } from 'react-router-dom';

import AppChrome from './app';
import Facilities from './facilities/facilities';
import ErrorPage from './failure-modes/error-page';
import NotFoundPage from './failure-modes/not-found';
import UnauthorizedPage from './failure-modes/unauthorized-page';
import { FeatureFlags } from './feature-flags/feature-flags';
import { Jurisdictions } from './jurisdictions';
import { Landing } from './landing';
import Logout from './logout/logout';
import { NurseLicenseCompacts } from './nurse-license-compacts';
import { OrientationMatches } from './orientation-matches';
import { PayrollInvoicing } from './payroll-invoicing';
import Invoices from './payroll-invoicing/invoices';
import Paychecks from './payroll-invoicing/paychecks';
import PayrollShifts from './payroll-invoicing/shifts';
import { PlatformAdmins } from './platform-admins';
import { Profiles } from './profiles';
import RateCalculator from './rate-calculator';
import { RegulatoryAssessments } from './regulatory-assessments';
import { Shifts } from './shifts';
import { Specialties } from './specialties';
import { TestData } from './test-data';

const children = [
    {
        index: true,
        path: '/',
        element: <Landing />,
    },
    {
        path: '/profiles',
        element: <Profiles />,
        children: [
            {
                path: ':selectionId',
            },
        ],
    },
    {
        path: '/facilities',
        element: <Facilities />,
    },
    {
        path: '/shifts',
        element: <Shifts />,
        children: [
            {
                path: ':selectionId',
            },
        ],
    },
    {
        path: '/jurisdictions',
        element: <Jurisdictions />,
    },
    {
        path: '/compacts',
        element: <NurseLicenseCompacts />,
    },
    {
        path: '/orientation-matches',
        element: <OrientationMatches />,
    },
    {
        path: '/platform-admins',
        element: <PlatformAdmins />,
    },
    {
        path: '/payroll',
        element: <PayrollInvoicing />,
        children: [
            {
                index: true,
                element: <Paychecks />,
                path: 'paychecks',
            },
            {
                element: <Invoices />,
                path: 'invoices',
            },
            {
                element: <PayrollShifts />,
                path: 'shifts',
            },
        ],
    },
    {
        path: '/rate-calculator',
        element: <RateCalculator />,
    },
    {
        path: '/feature-flags',
        element: <FeatureFlags />,
    },
    {
        path: '/specialties',
        element: <Specialties />,
    },
    {
        path: '/regulatory-assessments',
        element: <RegulatoryAssessments />,
    },
    {
        path: '/logout',
        element: <Logout />,
    },
];

if (ENV_CONFIG_VARS.ENVIRONMENT_NAME !== 'prod') {
    children.push({
        path: '/test-data',
        element: <TestData />,
    });
}

const router = createBrowserRouter([
    {
        path: '/',
        element: <AppChrome />,
        errorElement: <ErrorPage />,
        children,
    },
    {
        path: '/unauthorized',
        element: <UnauthorizedPage />,
        errorElement: <UnauthorizedPage />,
    },
    {
        path: '*',
        element: <NotFoundPage />,
    },
]);

export default router;
